import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-comment-renderer',
    template: `
    <div (click)="expandComment(); show = !show">{{ shortenedComment }}</div>
  `,
    standalone: false // NOSONAR
})
export class CommentRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public comment: string;
  public shortenedComment: string;
  show: boolean = false;
  trimmedComment: string;

  agInit(params: any): void {

    this.params = params;
    this.comment = params.value;
    if (this.comment != null && this.comment != '' && this.comment != undefined) {   // NOSONAR
      if (this.comment.length > 40) {
        this.trimmedComment = this.comment.substring(0, 40) + '...';
      }
      else {
        this.trimmedComment = this.comment;
      }
      this.shortenedComment = this.trimmedComment;
    } else {
      this.trimmedComment = '';
      this.shortenedComment = '';
    }


  }

  refresh(): boolean {
    return false;
  }

  expandComment() {
    // implement logic to expand comment
    if (this.show) {
      this.shortenedComment = this.comment;
    } else {
      this.shortenedComment = this.trimmedComment;
    }
  }
}
